import ICsvDateOutput from "../ICsvDateOutput";

export default (csvDate: ICsvDateOutput) => {
  const d = new FormData();
  // d.append("csvDate[id]", csvDate.id);
  d.append("csvDate[chengeDate]", csvDate.chengeDate);
  return d;
};
